<ul class="d-flex list-group">
  @if (customFields.length > 0) {
    @for (field of customFields; track field) {
      <li class="list-group-item p-3" style="overflow: hidden;">
        <div class="d-flex">
          <div class="me-2" style="max-width: 50%; word-wrap: break-word;" [title]="field.key">
            <span class="fw-bold">{{field.key}}</span>
          </div>
          <div style="max-width: max-content; overflow: hidden; word-wrap: break-word;;" [title]="parseSingleArrayItem(field.value)">
            @if (!isLink(field.value)) {
              <span style="user-select: text;">{{parseSingleArrayItem(field.value)}}</span>
            }
            @if (isLink(field.value)) {
              <a href="{{field.value}}" target="_blank">{{field.value}}</a>
            }
          </div>
        </div>
      </li>
    }
  }
</ul>